import { useTranslation } from "react-i18next"; 
import { OrganizationData } from "../../types/allorganization";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { setOrganization } from "../../redux/slices/organizationSlice";
import { Link } from "react-router-dom";

interface IOrganizationCardProps {
  index: number | null;
  connection: OrganizationData;
}

export const MyOrganizationCardAdvanceCCo = ({
  connection,
  index,
}: IOrganizationCardProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div className="cco_group_item tpCards" key={connection.OrgID + index}>
      <Link
        to={`/edit/${connection.OrganizationId}`}
        onClick={() => dispatch(setOrganization(connection))}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div className="cco_card cco_card_myCredential">
          <div className="cco_card_body">
            <div
              className="cco_card_main"
              style={{
                width: "100%",
                padding: "12px 16px",
              }}
            >
              <div className="cco_text cco_text_myCredential">
                <div className="cco_text_inner">
                  <h3
                    style={{
                      fontSize: "0.95rem",
                      marginBottom: "12px",
                    }}
                  >
                    <strong>{connection?.Name}</strong>
                  </h3>

                  <div className="organization-details" style={{ fontSize: "0.85rem" }}>
                    <div style={{ marginBottom: "6px" }}>
                      <strong>{t("MyCCOPro.myOrgCard.OrgId")}:</strong> {connection.OrgID}
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <strong>{t("MyCCOPro.myOrgCard.Address")}:</strong> {connection.Address1}, {connection.City}
                    </div>
                    <div>
                      <strong> {t("MyCCOPro.myOrgCard.Status")}:{' '}:</strong> {connection.StatusReason ? t(`MyCCOPro.myOrgCard.Statuses.${connection.StatusReason}`,connection.StatusReason) :''}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
